export const KEY_TEXT = "cascade-current-text";
export const KEY_TEXT_FONT = "cascade-current-text-font";
export const KEY_TEXT_FONT_SIZE = "cascade-current-text-font-size";
